var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.6 20.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#999;stroke-miterlimit:10;stroke-width:.6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.2,5.2c0,2.7-2.2,6.4-4.9,6.4-2.7,0-4.9-3.7-4.9-6.4S6.6,.3,9.3,.3c2.7,0,4.9,2.2,4.9,4.9h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,10.2c-1,1.3-2.3,2.2-3.7,2.2s-2.7-.9-3.7-2.2C2.5,11.5,.3,14.2,.3,16s4,4.5,9,4.5,9-2,9-4.5-2.2-4.5-5.3-5.8h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.23acc3d5ee6573cd89e2002d2918b19f.svg";
export { ForwardRef as ReactComponent };